import React from 'react';
import useStyleOverride from "../../hooks/useStyleOverride.js";
import baseStyles from "./styles.module.css.js";
import ArrowDown from "./chevron-down-icon.svg.js";
import ArrowUp from "./chevron-up-icon.svg.js";
export var GroupHeader = _ref => {
  var {
    results,
    groupProps,
    toggleCollapse,
    isCollapsed = false
  } = _ref;
  var styles = useStyleOverride('results/GroupHeader', baseStyles);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.GroupHeader
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.groupName
  }, groupProps.label), /*#__PURE__*/React.createElement("span", {
    className: styles.resultCount
  }, "(", results.length, ")"), toggleCollapse && /*#__PURE__*/React.createElement("span", {
    onClick: toggleCollapse,
    className: styles.toggleButton
  }, isCollapsed ? /*#__PURE__*/React.createElement(ArrowUp, null) : /*#__PURE__*/React.createElement(ArrowDown, null)));
};
export default GroupHeader;
//# sourceMappingURL=index.js.map